export { default } from './subcategory-page';
